import _ from 'lodash';
import React, {useState, useEffect} from 'react';
import {connectWithCore} from 'framework/hocs';
import {Header, Icon, Loader} from 'semantic-ui-react';
import {DeleteModal, FemaGoTable} from 'app-ui-componentlibrary';
import {Alert} from 'componentLibrary';
import {
  convertDateForDisplay,
  convertValueToDollar,
  formatDollarDecimals,
} from 'common/utils';
import {COMMITMENT_STATE} from 'common/requestDetails/constants';

const AwardAmountInput = ({
  entityIndex,
  amount,
  updateCommitment,
  index,
  displayCommitmentError,
}) => {
  const [awardAmount, setAwardAmount] = useState(amount);

  const handleChange = (value) => {
    setAwardAmount(value);
  };

  const handleBlur = () => {
    awardAmount != undefined &&
      awardAmount != null &&
      updateCommitment(entityIndex, index, formatDollarDecimals(awardAmount));
  };

  return (
    <FemaGoTable.DollarCell
      name="Amount awarded"
      title="Amount awarded"
      value={awardAmount}
      allowNegative={true}
      handleBlur={() => {
        handleBlur();
      }}
      handleChange={(name, value) => {
        handleChange(value);
      }}
      displayError={
        displayCommitmentError(entityIndex, index, 'awardAmount').displayError
      }
      errorMessages={
        displayCommitmentError(entityIndex, index, 'awardAmount').errorMessages
      }
    />
  );
};

export function FundingInformationCommitmentTable(props) {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [toDelete, setToDelete] = useState(null);
  const [nonMatchingRegion, setNonMatchingRegion] = useState(false);

  const {
    commitmentHeader,
    commitmentSummary,
    type,
    deleteModalHeader,
    deleteModalContent,
    removeCommitment,
    updateCommitment,
    editable,
    mappedCommitments,
    entityId,
    entityIndex,
    newCommitmentFeature,
    displayCommitmentError,
    displayRegionAlert,
    regionAlertHeader,
    regionAlertContent,
    organization,
    setSelectedCommitments,
    selectedCommitments,
    disableMultiCommitmentButton,
  } = props;

  const handleChange = (row, value) => {
    if (value) {
      setSelectedCommitments((previousCommitment) => [...previousCommitment, row]);
    } else {
      setSelectedCommitments((previousCommitment) =>
        _.without([...previousCommitment], row)
      );
    }
  };

  useEffect(() => {
    if (mappedCommitments && mappedCommitments.length > 0) {
      const isNonMatchingRegionExist = _.filter(mappedCommitments, function (commitment) {
        return commitment.region != organization.region;
      });
      setNonMatchingRegion(isNonMatchingRegionExist.length > 0);
    }
  }, [mappedCommitments, organization]);

  return (
    <React.Fragment>
      {commitmentHeader && <Header as="h2">{commitmentHeader}</Header>}
      {displayRegionAlert && nonMatchingRegion && (
        <Alert
          type="warning"
          id="nonMatchingRegionAlert"
          header={regionAlertHeader}
          content={regionAlertContent}
        />
      )}
      <FemaGoTable
        type="static"
        summary={commitmentSummary ? commitmentSummary : 'Commitments currently in use'}
      >
        <FemaGoTable.Header>
          <FemaGoTable.Row>
            {type === 'select' && <FemaGoTable.HeaderCell id="selectColumn" />}
            <FemaGoTable.HeaderCell>
              Commitment number - sequence number
            </FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>
              <center>Region</center>
            </FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>End date</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>ACCS code</FemaGoTable.HeaderCell>
            <FemaGoTable.HeaderCell>Available amount</FemaGoTable.HeaderCell>
            {type === 'edit' && (
              <FemaGoTable.HeaderCell>
                Amount awarded this action (+/-)
              </FemaGoTable.HeaderCell>
            )}
            {type === 'edit' && <FemaGoTable.HeaderCell />}
          </FemaGoTable.Row>
        </FemaGoTable.Header>
        <FemaGoTable.Body>
          {mappedCommitments &&
            mappedCommitments.map((row, index) => {
              const {
                commitmentNumberId,
                commitmentLineNumber,
                region,
                commitmentEndDate,
                accsline,
                commitmentAvailableAmount,
                awardAmount,
                state,
              } = row;

              let enableDelete = true;
              if (
                newCommitmentFeature &&
                !_.isNil(state) &&
                state === COMMITMENT_STATE.EXISTING
              ) {
                enableDelete = false;
              }
              let commitmentRegionMatch = region !== organization.region;
              return (
                <React.Fragment key={`commitmentFragment-${entityId}-${index}`}>
                  <FemaGoTable.Row key={index}>
                    {type === 'select' && (
                      <FemaGoTable.CheckboxCell
                        label="Select commitment"
                        hideLabel={true}
                        checked={_.includes(selectedCommitments, row)}
                        collapsing={true}
                        handleChange={(label, value) => {
                          handleChange(row, value);
                        }}
                      />
                    )}
                    <FemaGoTable.TextCell>
                      {commitmentNumberId + ' - ' + commitmentLineNumber}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      <center>
                        {displayRegionAlert && commitmentRegionMatch && (
                          <Icon name="exclamation triangle" color="yellow" />
                        )}
                        {region || ''}
                      </center>
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {convertDateForDisplay(commitmentEndDate, true)}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>{accsline}</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {convertValueToDollar(commitmentAvailableAmount)}
                    </FemaGoTable.TextCell>
                    {!editable && (
                      <FemaGoTable.TextCell id="staticAwardAmount">
                        {convertValueToDollar(awardAmount)}
                      </FemaGoTable.TextCell>
                    )}
                    {type === 'edit' && editable && (
                      <AwardAmountInput
                        id="awardAmountInput"
                        index={index}
                        entityIndex={entityIndex}
                        amount={awardAmount}
                        updateCommitment={updateCommitment}
                        displayCommitmentError={displayCommitmentError}
                      />
                    )}
                    {type === 'edit' &&
                      editable &&
                      enableDelete &&
                      !disableMultiCommitmentButton && (
                        <FemaGoTable.TextCell>
                          <a
                            href="#"
                            title="Delete"
                            onClick={() => {
                              setDeleteModalOpen(true);
                              setToDelete({commitmentNumberId, commitmentLineNumber});
                            }}
                          >
                            <Icon name="close" />
                          </a>
                        </FemaGoTable.TextCell>
                      )}
                  </FemaGoTable.Row>
                  {deleteModalOpen && toDelete && (
                    <DeleteModal
                      displayText={
                        deleteModalContent
                          ? deleteModalContent
                          : 'Please confirm that you want to remove associated commitment with the subapplication'
                      }
                      displayTitle={
                        deleteModalHeader ? deleteModalHeader : 'Confirm change'
                      }
                      open={deleteModalOpen}
                      cancelAction={() => {
                        setDeleteModalOpen(false);
                        setToDelete(null);
                      }}
                      deleteAction={() => {
                        removeCommitment(
                          entityIndex,
                          toDelete.commitmentNumberId,
                          toDelete.commitmentLineNumber
                        );
                        setToDelete(null);
                        setDeleteModalOpen(false);
                      }}
                    />
                  )}
                </React.Fragment>
              );
            })}
        </FemaGoTable.Body>
      </FemaGoTable>
    </React.Fragment>
  );
}

export default connectWithCore(FundingInformationCommitmentTable);
